import { map, mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';

import {
  INIT_STACKUP,
  ADD_LAYER,
  DELETE_LAYERS,
  UPDATE_LAYER,
  UPDATE_CALCULATIONS,
  TRIGGER_CALCULATIONS,
} from '../actions/action-types';
import { updateCalculation, updateCalculationFulfilled } from '../actions';
import { getStackupLayers } from '../reducers';
import simulate from '../lib/simulations';

export function startCalculationsEpic(action$, state$){
  return action$
    .pipe(
      ofType(INIT_STACKUP, ADD_LAYER, DELETE_LAYERS, UPDATE_LAYER, TRIGGER_CALCULATIONS),
      map(action => updateCalculation({
        triggeredBy: action.type,
        layers: getStackupLayers(state$.value)
      }))
    )
}

export function updateCalculationsEpic(action$){
  return action$
    .pipe(
      ofType(UPDATE_CALCULATIONS),
      mergeMap(action =>
        simulate(action.payload)
          .pipe(
            map(result => updateCalculationFulfilled(result))
          )
      )
    )
}




// WEBPACK FOOTER //
// ./src/epics/updateCalculations.js